<template>
    <div class="options" :theme="theme">
        <div class="options-title">{{title ? title : 'Select an Option'}}</div>
        <div class="options-list">
            <a class="option" v-for="(option, index) of options" :key="index" @click="select(option)" :class="option.color">{{option.title}}</a>
            <a class="option grey" @click="$emit('close')">Cancel</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Options',
        props: {
            title: String,
            options: Array
        },
        methods: {
            select(option){
                option.fn();
                this.$emit('close');
            }
        },
        computed: {
            theme(){
                return this.$store.state.theme.active;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    @option_height: 44px;

    .options
    {
        width: 260px;
        background: @f;
        border-radius: 5px;
        overflow: hidden;
    }

    .options-title
    {
        font-size: 12px;
        color: @grey;
        height: @option_height;
        line-height: @option_height;
        text-align: center;
    }

    .option
    {
        display: block;
        height: @option_height;
        line-height: @option_height;
        font-weight: 500;
        border-top: 1px solid @e4;
        text-align: center;
        font-size: 15px;
        color: @base;
        transition: background-color ease 0.2s;
        cursor: pointer;
        user-select: none;

        &.grey
        {
            color: @grey;
        }

        &.red
        {
            color: @red;
        }

        &:hover, &:active
        {
            background: @f4;
        }
    }
</style>
